module.exports = __webpack_public_path__ + "static/media/009-earth.75289520.svg";